import React, { useEffect, useRef, useState } from "react";
import { Breadcrumb, BreadcrumbItem, Container } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { contactUs } from "../api.services.js/others";
import swal from "sweetalert";
import Head from "next/head";
import { gtagConversionEvent } from "../gtag";
import axios from "axios";
import { Dropdown } from "react-bootstrap";
import ReactCountryFlag from "react-country-flag";
const Contact = () => {
  // State variables to store form data
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [subject, setSubject] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [country, setcountry] = useState("");
  const [countrycc, setcountrycc] = useState("");

  const isMounted = useRef(false);
  const [indianStates, setIndianStates] = useState([
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Lakshadweep",
    "Delhi",
    "Puducherry",
  ]);
  const countries = [
    { name: "Afghanistan", code: "93", cc: "AF" },
    { name: "Albania", code: "355", cc: "AL" },
    { name: "Algeria", code: "213", cc: "DZ" },
    { name: "American Samoa", code: "1-684", cc: "AS" },
    { name: "Andorra", code: "376", cc: "AD" },
    { name: "Angola", code: "244", cc: "AO" },
    { name: "Anguilla", code: "1-264", cc: "AI" },
    { name: "Antarctica", code: "672", cc: "AQ" },
    { name: "Antigua and Barbuda", code: "1-268", cc: "AG" },
    { name: "Argentina", code: "54", cc: "AR" },
    { name: "Armenia", code: "374", cc: "AM" },
    { name: "Aruba", code: "297", cc: "AW" },
    { name: "Australia", code: "61", cc: "AU" },
    { name: "Austria", code: "43", cc: "AT" },
    { name: "Azerbaijan", code: "994", cc: "AZ" },
    { name: "Bahamas", code: "1-242", cc: "BS" },
    { name: "Bahrain", code: "973", cc: "BH" },
    { name: "Bangladesh", code: "880", cc: "BD" },
    { name: "Barbados", code: "1-246", cc: "BB" },
    { name: "Belarus", code: "375", cc: "BY" },
    { name: "Belgium", code: "32", cc: "BE" },
    { name: "Belize", code: "501", cc: "BZ" },
    { name: "Benin", code: "229", cc: "BJ" },
    { name: "Bermuda", code: "1-441", cc: "BM" },
    { name: "Bhutan", code: "975", cc: "BT" },
    { name: "Bolivia", code: "591", cc: "BO" },
    { name: "Bosnia and Herzegovina", code: "387", cc: "BA" },
    { name: "Botswana", code: "267", cc: "BW" },
    { name: "Brazil", code: "55", cc: "BR" },
    { name: "British Indian Ocean Territory", code: "246", cc: "IO" },
    { name: "British Virgin Islands", code: "1-284", cc: "VG" },
    { name: "Brunei", code: "673", cc: "BN" },
    { name: "Bulgaria", code: "359", cc: "BG" },
    { name: "Burkina Faso", code: "226", cc: "BF" },
    { name: "Burundi", code: "257", cc: "BI" },
    { name: "Cambodia", code: "855", cc: "KH" },
    { name: "Cameroon", code: "237", cc: "CM" },
    { name: "Canada", code: "1", cc: "CA" },
    { name: "Cape Verde", code: "238", cc: "CV" },
    { name: "Cayman Islands", code: "1-345", cc: "KY" },
    { name: "Central African Republic", code: "236", cc: "CF" },
    { name: "Chad", code: "235", cc: "TD" },
    { name: "Chile", code: "56", cc: "CL" },
    { name: "China", code: "86", cc: "CN" },
    { name: "Christmas Island", code: "61", cc: "CX" },
    { name: "Cocos Islands", code: "61", cc: "CC" },
    { name: "Colombia", code: "57", cc: "CO" },
    { name: "Comoros", code: "269", cc: "KM" },
    { name: "Cook Islands", code: "682", cc: "CK" },
    { name: "Costa Rica", code: "506", cc: "CR" },
    { name: "Croatia", code: "385", cc: "HR" },
    { name: "Cuba", code: "53", cc: "CU" },
    { name: "Curacao", code: "599", cc: "CW" },
    { name: "Cyprus", code: "357", cc: "CY" },
    { name: "Czech Republic", code: "420", cc: "CZ" },
    { name: "Democratic Republic of the Congo", code: "243", cc: "CD" },
    { name: "Denmark", code: "45", cc: "DK" },
    { name: "Djibouti", code: "253", cc: "DJ" },
    { name: "Dominica", code: "1-767", cc: "DM" },
    { name: "Dominican Republic", code: "1-809, 1-829, 1-849", cc: "DO" },
    { name: "East Timor", code: "670", cc: "TL" },
    { name: "Ecuador", code: "593", cc: "EC" },
    { name: "Egypt", code: "20", cc: "EG" },
    { name: "El Salvador", code: "503", cc: "SV" },
    { name: "Equatorial Guinea", code: "240", cc: "GQ" },
    { name: "Eritrea", code: "291", cc: "ER" },
    { name: "Estonia", code: "372", cc: "EE" },
    { name: "Ethiopia", code: "251", cc: "ET" },
    { name: "Falkland Islands", code: "500", cc: "FK" },
    { name: "Faroe Islands", code: "298", cc: "FO" },
    { name: "Fiji", code: "679", cc: "FJ" },
    { name: "Finland", code: "358", cc: "FI" },
    { name: "France", code: "33", cc: "FR" },
    { name: "French Polynesia", code: "689", cc: "PF" },
    { name: "Gabon", code: "241", cc: "GA" },
    { name: "Gambia", code: "220", cc: "GM" },
    { name: "Georgia", code: "995", cc: "GE" },
    { name: "Germany", code: "49", cc: "DE" },
    { name: "Ghana", code: "233", cc: "GH" },
    { name: "Gibraltar", code: "350", cc: "GI" },
    { name: "Greece", code: "30", cc: "GR" },
    { name: "Greenland", code: "299", cc: "GL" },
    { name: "Grenada", code: "1-473", cc: "GD" },
    { name: "Guam", code: "1-671", cc: "GU" },
    { name: "Guatemala", code: "502", cc: "GT" },
    { name: "Guernsey", code: "44-1481", cc: "GG" },
    { name: "Guinea", code: "224", cc: "GN" },
    { name: "Guinea-Bissau", code: "245", cc: "GW" },
    { name: "Guyana", code: "592", cc: "GY" },
    { name: "Haiti", code: "509", cc: "HT" },
    { name: "Honduras", code: "504", cc: "HN" },
    { name: "Hong Kong", code: "852", cc: "HK" },
    { name: "Hungary", code: "36", cc: "HU" },
    { name: "Iceland", code: "354", cc: "IS" },
    { name: "India", code: "91", cc: "IN" },
    { name: "Indonesia", code: "62", cc: "ID" },
    { name: "Iran", code: "98", cc: "IR" },
    { name: "Iraq", code: "964", cc: "IQ" },
    { name: "Ireland", code: "353", cc: "IE" },
    { name: "Isle of Man", code: "44-1624", cc: "IM" },
    { name: "Israel", code: "972", cc: "IL" },
    { name: "Italy", code: "39", cc: "IT" },
    { name: "Ivory Coast", code: "225", cc: "CI" },
    { name: "Jamaica", code: "1-876", cc: "JM" },
    { name: "Japan", code: "81", cc: "JP" },
    { name: "Jersey", code: "44-1534", cc: "JE" },
    { name: "Jordan", code: "962", cc: "JO" },
    { name: "Kazakhstan", code: "7", cc: "KZ" },
    { name: "Kenya", code: "254", cc: "KE" },
    { name: "Kiribati", code: "686", cc: "KI" },
    { name: "Kosovo", code: "383", cc: "XK" },
    { name: "Kuwait", code: "965", cc: "KW" },
    { name: "Kyrgyzstan", code: "996", cc: "KG" },
    { name: "Laos", code: "856", cc: "LA" },
    { name: "Latvia", code: "371", cc: "LV" },
    { name: "Lebanon", code: "961", cc: "LB" },
    { name: "Lesotho", code: "266", cc: "LS" },
    { name: "Liberia", code: "231", cc: "LR" },
    { name: "Libya", code: "218", cc: "LY" },
    { name: "Liechtenstein", code: "423", cc: "LI" },
    { name: "Lithuania", code: "370", cc: "LT" },
    { name: "Luxembourg", code: "352", cc: "LU" },
    { name: "Macau", code: "853", cc: "MO" },
    { name: "Macedonia", code: "389", cc: "MK" },
    { name: "Madagascar", code: "261", cc: "MG" },
    { name: "Malawi", code: "265", cc: "MW" },
    { name: "Malaysia", code: "60", cc: "MY" },
    { name: "Maldives", code: "960", cc: "MV" },
    { name: "Mali", code: "223", cc: "ML" },
    { name: "Malta", code: "356", cc: "MT" },
    { name: "Marshall Islands", code: "692", cc: "MH" },
    { name: "Mauritania", code: "222", cc: "MR" },
    { name: "Mauritius", code: "230", cc: "MU" },
    { name: "Mayotte", code: "262", cc: "YT" },
    { name: "Mexico", code: "52", cc: "MX" },
    { name: "Micronesia", code: "691", cc: "FM" },
    { name: "Moldova", code: "373", cc: "MD" },
    { name: "Monaco", code: "377", cc: "MC" },
    { name: "Mongolia", code: "976", cc: "MN" },
    { name: "Montenegro", code: "382", cc: "ME" },
    { name: "Montserrat", code: "1-664", cc: "MS" },
    { name: "Morocco", code: "212", cc: "MA" },
    { name: "Mozambique", code: "258", cc: "MZ" },
    { name: "Myanmar", code: "95", cc: "MM" },
    { name: "Namibia", code: "264", cc: "NA" },
    { name: "Nauru", code: "674", cc: "NR" },
    { name: "Nepal", code: "977", cc: "NP" },
    { name: "Netherlands", code: "31", cc: "NL" },
    { name: "Netherlands Antilles", code: "599", cc: "AN" },
    { name: "New Caledonia", code: "687", cc: "NC" },
    { name: "New Zealand", code: "64", cc: "NZ" },
    { name: "Nicaragua", code: "505", cc: "NI" },
    { name: "Niger", code: "227", cc: "NE" },
    { name: "Nigeria", code: "234", cc: "NG" },
    { name: "Niue", code: "683", cc: "NU" },
    { name: "North Korea", code: "850", cc: "KP" },
    { name: "Northern Mariana Islands", code: "1-670", cc: "MP" },
    { name: "Norway", code: "47", cc: "NO" },
    { name: "Oman", code: "968", cc: "OM" },
    { name: "Pakistan", code: "92", cc: "PK" },
    { name: "Palau", code: "680", cc: "PW" },
    { name: "Palestine", code: "970", cc: "PS" },
    { name: "Panama", code: "507", cc: "PA" },
    { name: "Papua New Guinea", code: "675", cc: "PG" },
    { name: "Paraguay", code: "595", cc: "PY" },
    { name: "Peru", code: "51", cc: "PE" },
    { name: "Philippines", code: "63", cc: "PH" },
    { name: "Pitcairn", code: "64", cc: "PN" },
    { name: "Poland", code: "48", cc: "PL" },
    { name: "Portugal", code: "351", cc: "PT" },
    { name: "Puerto Rico", code: "1-787, 1-939", cc: "PR" },
    { name: "Qatar", code: "974", cc: "QA" },
    { name: "Republic of the Congo", code: "242", cc: "CG" },
    { name: "Reunion", code: "262", cc: "RE" },
    { name: "Romania", code: "40", cc: "RO" },
    { name: "Russia", code: "7", cc: "RU" },
    { name: "Rwanda", code: "250", cc: "RW" },
    { name: "Saint Barthelemy", code: "590", cc: "BL" },
    { name: "Saint Helena", code: "290", cc: "SH" },
    { name: "Saint Kitts and Nevis", code: "1-869", cc: "KN" },
    { name: "Saint Lucia", code: "1-758", cc: "LC" },
    { name: "Saint Martin", code: "590", cc: "MF" },
    { name: "Saint Pierre and Miquelon", code: "508", cc: "PM" },
    { name: "Saint Vincent and the Grenadines", code: "1-784", cc: "VC" },
    { name: "Samoa", code: "685", cc: "WS" },
    { name: "San Marino", code: "378", cc: "SM" },
    { name: "Sao Tome and Principe", code: "239", cc: "ST" },
    { name: "Saudi Arabia", code: "966", cc: "SA" },
    { name: "Senegal", code: "221", cc: "SN" },
    { name: "Serbia", code: "381", cc: "RS" },
    { name: "Seychelles", code: "248", cc: "SC" },
    { name: "Sierra Leone", code: "232", cc: "SL" },
    { name: "Singapore", code: "65", cc: "SG" },
    { name: "Sint Maarten", code: "1-721", cc: "SX" },
    { name: "Slovakia", code: "421", cc: "SK" },
    { name: "Slovenia", code: "386", cc: "SI" },
    { name: "Solomon Islands", code: "677", cc: "SB" },
    { name: "Somalia", code: "252", cc: "SO" },
    { name: "South Africa", code: "27", cc: "ZA" },
    { name: "South Korea", code: "82", cc: "KR" },
    { name: "South Sudan", code: "211", cc: "SS" },
    { name: "Spain", code: "34", cc: "ES" },
    { name: "Sri Lanka", code: "94", cc: "LK" },
    { name: "Sudan", code: "249", cc: "SD" },
    { name: "Suriname", code: "597", cc: "SR" },
    { name: "Svalbard and Jan Mayen", code: "47", cc: "SJ" },
    { name: "Swaziland", code: "268", cc: "SZ" },
    { name: "Sweden", code: "46", cc: "SE" },
    { name: "Switzerland", code: "41", cc: "CH" },
    { name: "Syria", code: "963", cc: "SY" },
    { name: "Taiwan", code: "886", cc: "TW" },
    { name: "Tajikistan", code: "992", cc: "TJ" },
    { name: "Tanzania", code: "255", cc: "TZ" },
    { name: "Thailand", code: "66", cc: "TH" },
    { name: "Togo", code: "228", cc: "TG" },
    { name: "Tokelau", code: "690", cc: "TK" },
    { name: "Tonga", code: "676", cc: "TO" },
    { name: "Trinidad and Tobago", code: "1-868", cc: "TT" },
    { name: "Tunisia", code: "216", cc: "TN" },
    { name: "Turkey", code: "90", cc: "TR" },
    { name: "Turkmenistan", code: "993", cc: "TM" },
    { name: "Turks and Caicos Islands", code: "1-649", cc: "TC" },
    { name: "Tuvalu", code: "688", cc: "TV" },
    { name: "U.S. Virgin Islands", code: "1-340", cc: "VI" },
    { name: "Uganda", code: "256", cc: "UG" },
    { name: "Ukraine", code: "380", cc: "UA" },
    { name: "United Arab Emirates", code: "971", cc: "AE" },
    { name: "United Kingdom", code: "44", cc: "GB" },
    { name: "United States", code: "1", cc: "US" },
    { name: "Uruguay", code: "598", cc: "UY" },
    { name: "Uzbekistan", code: "998", cc: "UZ" },
    { name: "Vanuatu", code: "678", cc: "VU" },
    { name: "Vatican", code: "379", cc: "VA" },
    { name: "Venezuela", code: "58", cc: "VE" },
    { name: "Vietnam", code: "84", cc: "VN" },
    { name: "Wallis and Futuna", code: "681", cc: "WF" },
    { name: "Western Sahara", code: "212", cc: "EH" },
    { name: "Yemen", code: "967", cc: "YE" },
    { name: "Zambia", code: "260", cc: "ZM" },
    { name: "Zimbabwe", code: "263", cc: "ZW" },
  ];
  const addtoanalytics = async () => {
    let ipInfo = await axios.get("https://obl-js.orientbell.com/api/ipinfo");
    
    if (ipInfo.data?.response?.country) {
      const selectedCountry = countries.find(
        (country) => country.name === ipInfo.data?.response?.country
      );
      setcountry(ipInfo.data?.response?.country);
      setcountrycc(selectedCountry ? selectedCountry.cc : "");
      // setcountry(ipInfo.data?.response?.country)
      await axios.post("https://proxy.orientbell.com/api/countrydata", {
        country: ipInfo.data?.response?.country,
      });
    }
  };
  useEffect(() => {
    if (!isMounted.current) {
      addtoanalytics();
      isMounted.current = true;
    }
  }, []);
  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    // gtagConversionEvent()
    setLoading(true);
    const selectedCountry = countries.find(
      (countryy) => countryy.name === country
    );
    console.log(selectedCountry);
    let response = await contactUs({
      name,
      phone: `+${selectedCountry.code} ${phone}`,
      state,
      city,
      subject,
      email,
      message,
      country,
    });
    if (response.message) {
      swal(response.message);
      setLoading(false);
    } else {
      swal(response.data.contact_us.msg);
      setLoading(false);
      setMessage("");
      setEmail("");
      setSubject("");
      setCity("");
      setState("");
      setPhone("");
      setName("");
      setcountry("");
    }
  };

  const breadCrumbSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [{
          "@type": "ListItem", 
          "position": 1, 
          "name": "Home",
          "item": "https://www.orientbell.com"
        },{
        "@type": "ListItem", 
        "position": 2, 
        "name": "Contact Us",
        "item": "https://obl-new.orientbell.com/contact-us"
      }]
      }`,
    };
  };
  return (
    <>
      <Head>
        <title>Contact Us - Corporate Office | Orientbell Tiles</title>
        <meta
          name="title"
          content="Contact Us - Corporate Office | Orientbell Tiles"
        />
        <meta
          name="description"
          content="Contact Orientbell for sales queries, feedback or inquiries about the ceramic & vitrified tiles. Find Orientbell's corporate office address and toll-free number."
        />
        <meta
          name="keywords"
          content="orientbell contact, contact orientbell, orientbell enquiries, orientbell contact information"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={breadCrumbSchema()}
        />
      </Head>
      <div className="contactus_page">
        <Container>
          <Breadcrumb>
            <BreadcrumbItem href="https://obl-new.orientbell.com/">
              Home
            </BreadcrumbItem>
            <BreadcrumbItem href="#">Contact Us</BreadcrumbItem>
          </Breadcrumb>
          <h1>Contact Us</h1>
          <p>
            The Orientbell Tile store is a one-stop-solution for all your tiling
            needs in ceramic and vitrified tiles. With an incredible range of
            floor and wall tiles, this is indeed one of the best tile shops that
            allow you to select the perfect tiles for your home and offices. You
            can now visualize your space with your preferred tile designs for
            free by using quicklook tool available at Orientbell Tile boutiques
            and choose the tiling options best suited for your style, budget,
            and other preferences at the tile showroom near you. Shopping for
            tiles was never this easy and hassle-free.
          </p>

          <div className="contactus_data">
            <div className="contactus_data_con">
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Form.Group
                    className="mb-3"
                    as={Col}
                    lg="6"
                    controlId="validationCustom01"
                  >
                    <Form.Label>Your Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Full Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </Form.Group>
                  <Form.Group
                    className="mb-3"
                    as={Col}
                    lg="6"
                    controlId="validationCustom02"
                  >
                    <Form.Label>Contact Number</Form.Label>

                    <Form.Control
                      type="number"
                      inputMode="numeric"
                      pattern="[0-9]{10}"
                      placeholder="Your Contact"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      required
                      onInput={(e) => {
                        const value = e.target.value;
                        if (!/^\d{10,13}$/.test(value)) {
                          e.target.setCustomValidity(
                            "Please enter a mobile number between 10 to 13 digits."
                          );
                        } else {
                          e.target.setCustomValidity("");
                        }
                      }}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <div className="mb-3 country-number-row" lg="12">
                    <Form.Label>Country</Form.Label>
                    <Dropdown
                      className="mb-3"
                      as={Col}
                      lg="12"
                      controlId="validationCustom01"
                      onSelect={(selectedCountryCode) => {
                        const selectedCountry = countries.find(
                          (country) => country.code === selectedCountryCode
                        );
                        setcountry(selectedCountry.name);
                        setcountrycc(selectedCountry ? selectedCountry.cc : "");
                      }}
                    >
                      <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                        {country && (
                          <div>
                            <ReactCountryFlag countryCode={countrycc} svg />
                            {` (${country})`}
                          </div>
                        )}
                        {!country && "Country Code"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{ maxHeight: "200px", overflowY: "auto" }}
                      >
                        {countries.map((country) => (
                          <Dropdown.Item
                            key={country.code}
                            eventKey={country.code}
                          >
                            <div>
                              <ReactCountryFlag countryCode={country.cc} svg />
                              {`${country.name} (${country.code})`}
                            </div>
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </Row>
                {country == "India" && (
                  <Row>
                    <Form.Group
                      className="mb-3"
                      as={Col}
                      lg="6"
                      controlId="validationCustom01"
                    >
                      <Form.Label>State</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                      >
                        <option value="">State</option>
                        {indianStates.sort().map((cur, inn) => {
                          return (
                            <option key={inn} value={cur}>
                              {cur}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                    <Form.Group
                      className="mb-3"
                      as={Col}
                      lg="6"
                      controlId="validationCustom02"
                    >
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Your City"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                      />
                    </Form.Group>
                  </Row>
                )}
                <Row>
                  <Form.Group
                    className="mb-3"
                    as={Col}
                    lg="6"
                    controlId="validationCustom01"
                  >
                    <Form.Label>Subject</Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      required
                    >
                      <option value="">Select Your Enquiry</option>
                      <option value="Home">Home</option>
                      <option value="Commercial/Business">
                        Commercial/Business
                      </option>
                      <option value="Others">Others</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group
                    className="mb-3"
                    as={Col}
                    lg="6"
                    controlId="validationCustom02"
                  >
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Email:"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mb-3">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      placeholder="Your Message"
                      style={{ height: "100px" }}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Row>
                <div className="contactus_bottom_form">
                  <Form.Group>
                    <Form.Check
                      label="I abide by the Orientbell Privacy Policy"
                      feedback="You must agree before submitting."
                      feedbackType="invalid"
                      required
                    />
                  </Form.Group>
                  {loading ? (
                    <Button variant="secondary">Submitting</Button>
                  ) : (
                    <Button type="submit" variant="primary">
                      Submit
                    </Button>
                  )}
                </div>
              </Form>
            </div>
            <div className="contactus_data_con">
              <p>
                <strong>Corporate Office</strong>
              </p>
              <p>
                Iris House, 16 Business Centre, Nangal Raya, DDA
                <br />
                Complex, New Delhi – 110046 (India)CIN:
                <br />
                L14101UP1977PLC021546
                <br />
                Call Toll Free: 1800 208 1015
              </p>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14010.547172741708!2d77.109074!3d28.610671!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1cacbfffffff%3A0x9bb8058abbee3f44!2sOrientbell%20Tiles%20Corporate%20Office!5e0!3m2!1sen!2sin!4v1688019901499!5m2!1sen!2sin"
                width="100%"
                height="auto"
              ></iframe>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Contact;
